import { Injectable } from '@angular/core'

import { Empresa } from '../../pkw-data/core/empresa.model'
import { PkwDatastore } from '../../pkw-data/pkw-datastore'

@Injectable()
export class EmpresaService {
    constructor(private pkwDatastore: PkwDatastore) {}

    obterTodas() {
        return this.pkwDatastore
            .findAll(Empresa, {page: {limit: 9999 }})
            .map(response => response.getModels())
    }

    obterAtivas() {
        return this.pkwDatastore
            .findAll(Empresa, {filter: {ativa: true}, page: {limit: 9999}})
            .map(response => response.getModels())
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/empresa.service.ts